<template>
  <div v-show="showLoad" class="loading">
    <p><i class="el-icon-loading"></i>正在加载</p>
  </div>
</template>
<script>
  export default {
    data(){
      return{

      }
    },
    props:['showLoad'],
  }
</script>
<style scoped>
  .loading{
    text-align: center;
    color: #999;
  }
  .loading i{
    vertical-align: middle;
    margin-right: 5px;
    text-indent: 0;
  }
  .loading p{
    vertical-align: middle;
    line-height: 40px;
    margin-top: 120px;
    text-indent: 0;
  }
</style>
